import React from "react";
import PropTypes from "prop-types";
import {Redirect, Route, Switch} from "react-router-dom";
// Creates a beautiful scrollbar
import "perfect-scrollbar/css/perfect-scrollbar.css";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import routes from "routes.js";
import AuthService from "customs/auth/AuthService";
import {connect} from "react-redux";

import helpers from "customs/helpers/helpers";

import appStyle from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.jsx";

let ps;

class Dashboard extends React.Component {

    constructor (props) {

        super(props);
        this.state = {
            "mobileOpen": false,
            "miniActive": false,
            "image": require("assets/img/sidebar-2.jpg"),
            "color": "blue",
            "bgColor": "black",
            "hasImage": true,
            "fixedClasses": "dropdown",
            "logo": `${process.env.PUBLIC_URL}/images/mini-logo.png`
        };

        this.scrollToOffset = this.scrollToOffset.bind(this);

    }

  mainPanel = React.createRef();
  componentDidMount () {
  }

  componentWillUnmount () {
      if (navigator.platform.indexOf("Win") > -1) {
        try {ps.destroy();} catch(err){}
      }
      window.removeEventListener(
          "resize",
          this.resizeFunction
      );
  }

  componentDidUpdate (e) {
      if (e.history.location.pathname !== e.location.pathname) {
          this.mainPanel.current.scrollTop = 0;
          if (this.state.mobileOpen) {
              this.setState({"mobileOpen": false});
          }
      }
  }

  handleImageClick = (image) => {
      this.setState({image});
  };

  handleColorClick = (color) => {
      this.setState({color});
  };

  handleBgColorClick = (bgColor) => {
      switch (bgColor) {
        case "white":
            this.setState({
                "logo": `${process.env.PUBLIC_URL}/images/mini-logo.png`
            });
            break;
        default:
            this.setState({
                "logo": `${process.env.PUBLIC_URL}/images/mini-logo.png`
            });
            break;
      }
      this.setState({bgColor});
  };

  handleFixedClick = () => {
      if (this.state.fixedClasses === "dropdown") {
          this.setState({"fixedClasses": "dropdown show"});
      } else {
          this.setState({"fixedClasses": "dropdown"});
      }
  };

  handleDrawerToggle = () => {
      this.setState({"mobileOpen": !this.state.mobileOpen});
  };

  getRoute = () => window.location.pathname !== "/admin/full-screen-maps";

  getActiveRoute = (routes) => {
      const activeRoute = "Default Brand Text";
      for (let i = 0; i < routes.length; i++) {
          if (routes[i].collapse) {
              const collapseActiveRoute = this.getActiveRoute(routes[i].views);
              if (collapseActiveRoute !== activeRoute) {
                  return collapseActiveRoute;
              }
          } else if (
              window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
          ) {
              return routes[i].name;
          }
      }
      return activeRoute;
  };

  scrollToOffset(offset) {
    try {
        this.mainPanel.current.scrollTo({top: offset, left: 0, behavior: 'smooth' });
    } catch(e) {
        try {
            this.mainPanel.current.scrollTop = offset;
        } catch(e1) {}
    }
  }

  getRoutes = (routes, rest) => routes.map((prop, key) => {
      if (prop.collapse) {
          return this.getRoutes(prop.views, rest);
      }
      if (prop.layout === "/admin") {
          return (
              <Route
                  render={(props) => <prop.component scrollToOffset={this.scrollToOffset} {...props} {...rest} />}
                  key={key}
                  path={prop.layout + prop.path}
              />
          );
      }
      return null;
  });

  shouldComponentUpdate(nextProps, nextState) {
      if (nextProps.location.pathname === this.props.location.pathname) {
          return false;
      }
      return true;
  }

  sidebarMinimize = () => {
      this.setState({"miniActive": !this.state.miniActive});
  };

  resizeFunction = () => {
      if (window.innerWidth >= 960) {
          this.setState({"mobileOpen": false});
      }
  };

  render () {
      const {classes, ...rest} = this.props,
          authService = new AuthService(
              this.state,
              this.props
          );
      return (
          <div>
              <div>
                  {!authService.getToken()
                      ? <Redirect
                          from="/admin"
                          to="/auth/login"
                        />
                      : this.getRoute()
                          ? <div>
                              <div className={classes.container}>
                                  <Switch>
                                      {this.getRoutes(routes, rest)}
                                      <Redirect
                                          from="/admin"
                                          to="/auth/login"
                                      />
                                  </Switch>
                              </div>
                          </div>
                          : <div className={classes.map}>
                              <Switch>
                                  {this.getRoutes(routes, rest)}
                                  <Redirect
                                      from="/admin"
                                      to="/auth/login"
                                  />
                              </Switch>
                          </div>}
              </div>
          </div>
      );
  }
}

Dashboard.propTypes = {
    "classes": PropTypes.object.isRequired
};

const mapStateToProps = (state, props) => {
    helpers.hideLoading();
    return {
        "auth": state.auth.data
    };
};

export default connect(mapStateToProps)(withStyles(appStyle)(Dashboard));
